import { render } from "./ListChannels.vue?vue&type=template&id=2bff9529"
import script from "./ListChannels.vue?vue&type=script&lang=js"
export * from "./ListChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__